module.exports = __webpack_public_path__ + "static/img/home.bd2372e8.png";